const TREECLIENTMENTOR = {
  start: {
    label: "Clients SOPs",
    details: (
      <ul>
        <li>Standard Operating Procedures for Client Management</li>
        <li>Guidelines and best practices for working with clients</li>
        <li>Understanding client mode functionality and workflows</li>
      </ul>
    ),
    children: ["clientModeGuide"],
  },
  
  clientModeGuide: {
    label: "Understanding Client Mode",
    details: (
      <ul>
        <li>How client mode works in the system</li>
        <li>Navigating the client interface</li>
        <li>Understanding permissions and access levels</li>
        <li>Best practices for client management</li>
      </ul>
    ),
    page: "static_html_content_client_mentor/client-mode-guide",
    children: [],
  },
};

export default TREECLIENTMENTOR;
export const ROOT_ID = "start";

